import React from "react";

interface KxdCoreIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KxdCoreIcon: React.FC<KxdCoreIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M11.8145 6.58105C12.2983 6.58107 12.7274 6.87905 12.877 7.31836L13.998 10.6133C14.1475 11.0526 13.9832 11.5342 13.5918 11.8057L10.6562 13.8418C10.2649 14.1131 9.73509 14.1131 9.34375 13.8418L6.4082 11.8057C6.01682 11.5342 5.85255 11.0526 6.00195 10.6133L7.12305 7.31836C7.27255 6.87905 7.70173 6.58107 8.18555 6.58105H11.8145ZM8.8418 7.44434C8.35816 7.44444 7.92985 7.74157 7.78027 8.18066L7.06445 10.2832C6.91496 10.7224 7.07844 11.204 7.46973 11.4756L9.34375 12.7754C9.73511 13.0467 10.2649 13.0467 10.6562 12.7754L12.5303 11.4756C12.9216 11.204 13.085 10.7224 12.9355 10.2832L12.2197 8.18066C12.0702 7.74157 11.6418 7.44444 11.1582 7.44434H8.8418Z" fill="#002366"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.333 0C18.775 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22496 20 1.66699V18.333C20 18.775 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.775 20 18.333 20H1.66699C1.22496 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.775 0 18.333V1.66699C0 1.22496 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22496 0 1.66699 0H18.333ZM6.98242 5C6.49872 5 6.06955 5.29722 5.91992 5.73633L4.05469 11.2168C3.90516 11.6561 4.06949 12.1377 4.46094 12.4092L9.34375 15.7959C9.73519 16.0674 10.2648 16.0674 10.6562 15.7959L15.5391 12.4092C15.9305 12.1377 16.0948 11.6561 15.9453 11.2168L14.0801 5.73633C13.9304 5.29722 13.5013 5 13.0176 5H6.98242Z" fill="#002366"/>
    </svg>
  );
};

export default KxdCoreIcon;
